import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getAmount, getDateWithDay } from "../../utils/Utils";
import { CountComm } from "../CountComm";
import { Pagination } from "./Pagination";
import useAuth from "../../providers/authProvider";

export function Table({ result, headers, details, clickables, changePage, tooltips, filterResult, sortable, update, FormUpdate }: any) {
    const { role } = useAuth();
    let [rowSelected, setRowSelected] = useState(-1);
    const navigate = useNavigate();
    const load = useSelector((state: any) => state.loader.value)
    let [filterSelected, setFilterSelected] = useState('');
    let [orderSelected, setOrderSelected] = useState('');
    let [fieldSelected, setFieldSelected] = useState('');

    function filter(header: string) {
        let order = 'asc';
        if (filterSelected === header && orderSelected === 'asc') {
            order = 'desc'
        }
        filterResult(`&sort=${header},${order}`)
        setFilterSelected(header)
        setOrderSelected(order)
    }

    function getNavigate(url: string, header: string, element: any) {
        if (header === 'escrow_transfer_id') {
            url += '&operators=' + element.operator
        }
        navigate(url)
    }

    return (<>{!load && <div>
        <div className="block vtmn-flex vtmn-flex-row vtmn-flex-wrap vtmn-justify-center vtmn-mb-4">
            <p className="vtmn-typo_title-5">Total : {result?.total_elements}</p>
        </div>
        <table className="vtmn-table-fixed">
            <thead>
                <tr>
                    {headers.map((header: string, i: Number) => {
                        return (<>{i === 0 && <td></td>}
                            <th onClick={() => sortable && sortable.indexOf(header) !== -1 ? filter(header) : null}
                                key={header}
                                className={`${sortable && sortable.indexOf(header) !== -1 ? 'vtmn-cursor-pointer' : ''}`}>
                                {sortable && sortable.indexOf(header) !== -1 && <Sortable orderSelected={orderSelected} filterSelected={filterSelected} >{header.replaceAll('_', ' ')}</Sortable>}
                                {(!sortable || (sortable && sortable.indexOf(header) === -1)) && <>{header.replaceAll('_', ' ')}</>}
                            </th>

                        </>
                        )
                    })}
                    {update && role === 'ADMIN' && <th style={{paddingLeft: '0px'}}>
                    
                    </th>}
                </tr>
            </thead>
            <tbody>
                {result.content.map((element: any, index: number) => {
                    return (
                        <>
                            <tr className="header" onClick={() => details ? setRowSelected(rowSelected === index ? -1 : index) : null} key={index}>
                                {headers.map((header: string, i: number) => {
                                    return (<>{i === 0 && <td>
                                        {details &&
                                            <span className="vtmn-text-active-brand vtmx-eye-fill" aria-hidden="true"></span>}
                                    </td>}
                                        <td key={`${header}-${index}`} className={clickables && clickables[header] && element[header] ? 'vtmn-link' : header.indexOf('amount') !== -1 ? 'vtmn-text-right' : ''} onClick={() => clickables && clickables[header] && element[header] ? getNavigate(clickables[header] + element[header], header, element) : null}>
                                            {header.indexOf('amount') !== -1 && <>
                                                <Tooltip tooltips={tooltips} field={header}>{getAmount(element[header], element["currency"])}</Tooltip>
                                            </>}
                                            {header.indexOf('date') !== -1 && <>
                                                <Tooltip tooltips={tooltips} field={header}>{element[header] ? getDateWithDay(element[header]) : null}</Tooltip>
                                            </>}
                                            {header.indexOf('amount') === -1 && header.indexOf('date') === -1 && <>
                                                <Tooltip tooltips={tooltips} field={header}>{typeof element[header] === 'object' ? element[header].map((v: string, index: number) => index === element[header].length - 1 ? v : `${v} / `) : element[header]}</Tooltip>
                                            </>}
                                        </td></>)
                                })}
                                {update && role === 'ADMIN' && <td className="vtmn-text-center" onClick={() => setFieldSelected(element)}>
                                    <span style={{ fontSize: '15px', width: '15px', paddingLeft: '0px' }} className="vtmx-edit-line" aria-hidden="true"></span>
                                </td>}
                            </tr>
                            {rowSelected === index && <tr className="detail" key={`${index}detail`}>
                                <td colSpan={update && role === 'ADMIN' ? headers.length + 2 : headers.length + 1}>
                                    <div className="vtmn-grid vtmn-grid-cols-3 vtmn-gap-0">
                                        {details.map((detail: string) => {
                                            return <>{element[detail] && <p className="block"><span className="vtmn-capitalize">{`${detail.replaceAll('_', ' ')} : `}  </span>
                                                {detail.indexOf('amount') !== -1 && <>
                                                    <Tooltip tooltips={tooltips} field={detail}>{getAmount(element[detail], element["currency"])}</Tooltip>
                                                </>}
                                                {detail.indexOf('date') !== -1 && detail !== 'validated' && <>
                                                    <Tooltip tooltips={tooltips} field={detail}>{element[detail] ? getDateWithDay(element[detail]) : null}</Tooltip>
                                                </>}
                                                {(detail.indexOf('amount') === -1 && detail.indexOf('date') === -1) && <>
                                                    <Tooltip tooltips={tooltips} field={detail}>{typeof element[detail] === 'object' ? element[detail].map((v: string, index: number) => index === element[detail].length - 1 ? v : `${v} / `) : element[detail]}</Tooltip>
                                                </>}
                                                {(detail === 'validated') && <>
                                                    <input
                                                        className="vtmn-checkbox"
                                                        type="checkbox"
                                                        id={`${index}checkbox${headers}`}
                                                        checked={element[detail]}
                                                        disabled={true}
                                                    /><label htmlFor={`${index}checkbox${headers}`}></label>
                                                </>}
                                            </p>}</>
                                        })}
                                        {element['commissions'] && <CountComm commissions={element['commissions']} operatorName={element['operators']} currency={element["currency"]} />}
                                    </div>

                                </td>
                            </tr>}
                        </>
                    )
                })}
            </tbody>
        </table>
        <Pagination result={result} changePage={changePage} />
    </div>}
    { fieldSelected && <ModalUpdate FormUpdate={FormUpdate} fieldSelected={fieldSelected} setFieldSelected={setFieldSelected}/> }
    </>)
}

export function Tooltip({ children, tooltips, field }: any) {
    return (<>{tooltips && tooltips[field] ? <span
        id="vtmn-tooltip-7"
        className="vtmn-tooltip"
        data-tooltip={tooltips[field].find((v: any) => v.value === children)?.description}
        data-position="top"
        role="tooltip"
    >
        <p aria-describedby="vtmn-tooltip-7">{children}</p>
    </span> : children}
    </>
    )
}

export function Sortable({ children, orderSelected, filterSelected }: any) {
    return (<p className="vtmn-flex vtmn-items-center">
        {children}
        {orderSelected === 'asc' && filterSelected === children && <span className="vtmx-arrow-up-line" aria-hidden="true"></span>}
        {orderSelected === 'desc' && filterSelected === children && <span className="vtmx-arrow-down-line" aria-hidden="true"></span>}
    </p>)
}

export function ModalUpdate({FormUpdate, fieldSelected, setFieldSelected}: any) {
    return (<div className="block">
    <div
      className="vtmn-modal"
      id="modal-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="vtmn-modal-title"
      aria-describedby="vtmn-modal-description"
    >
      <div className="vtmn-modal_content">
        <div className="vtmn-modal_content_title">
          <span id="vtmn-modal-title" className="vtmn-modal_content_title--text"
            >Update</span>
          <button className="vtmn-btn vtmn-btn_variant--ghost vtmn-btn--icon-alone" onClick={() => setFieldSelected(null)}>
            <span className="vtmx-close-line" aria-hidden="true"></span>
            <span className="vtmn-sr-only">Close modal</span>
          </button>
        </div>
        {FormUpdate && <FormUpdate fieldSelected={fieldSelected} setFieldSelected={setFieldSelected}/>}
      </div>
    </div>
  </div>)
}
